import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment-timezone';
@Pipe({
  name: 'logbookDatePipe',
})
export class LogbookDatePipe implements PipeTransform {
  transform(dateStr: string, timezone: string): string {
    return moment.tz(dateStr, timezone).format('h:mm:ss A');
  }
}
